export default {
  actions: {
    ...require('./heatmap/actions'),
    getHeatmapRequest: require('./heatmap/helpers/getHeatmapRequest'),
    ...require('./suggests/actions'),
    ...require('./search/actions'),
    sendSearchStats: () => () => {}, // return empty function
  },
  heatmap: require('./heatmap/heatmap'),
  suggests: require('./suggests/suggests'),
};
